<template>
  <q-page padding>
    <!-- content -->
    <div v-if="tab === 'enter'" class="text-primary text-h6">
      Reservationen:
      <span class="text-grey-8">
        {{ $q.platform.is.desktop ? 'Kalenderwoche' : 'KW' }} {{ week }}
      </span>
    </div>
    <div v-else class="text-primary text-h6">
      Reservationen
    </div>

    <q-tabs
      v-model="reservationsTab"
      dense
      class="text-grey q-mt-sm"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="enter" label="Eintragen" />
      <q-tab name="show" label="Anzeigen" />
    </q-tabs>

    <q-separator />

    <q-tab-panels
      v-model="reservationsTab"
      :class="[$q.platform.is.desktop ? 'q-mt-md' : 'q-mt-sm']"
    >
      <q-tab-panel name="enter" class="tab-panel">

      <template v-if="showPensumMessage" class="">
        <div class="q-gutter-sm">
        <q-banner inline-actions class="q-mb-md text-black bg-red-2">
          <b>Regulärer Unterricht nach Pensum hat immer Priorität:</b>
          Bitte bei den rot markierten Zimmern vor einer Reservation im Pensum prüfen, ob die gewünschten Lektionen frei sind.
          </q-banner>
      </div>
      </template>

        <template>
          <q-btn-group outline spread push flat class="q-pb-md" style="height:70px;">
            <q-btn :size="$q.platform.is.mobile ? 'sm' : ''" outline color="primary" label="Räume" @click="roomDialog = true" class="border-radius-0">
            <q-tooltip :delay="1000">
              Räume auswählen
            </q-tooltip>
            </q-btn>
            <q-btn
              :size="$q.platform.is.mobile ? 'sm' : ''"
              outline
              color="primary"
              icon="first_page"
              @click="jumpDate('week', 'back')"
            >
            <q-tooltip :delay="1000">
              Eine Woche zurück
            </q-tooltip>
            </q-btn>
            <q-btn :size="$q.platform.is.mobile ? 'sm' : ''" outline color="primary" icon="chevron_left" @click="jumpDate('day', 'back')">
            <q-tooltip :delay="1000">
              Einen Tag zurück
            </q-tooltip>
            </q-btn>
            <q-btn :size="$q.platform.is.mobile ? 'sm' : ''" outline color="primary" :label="pickerLabel">
              <q-popup-proxy ref="dateProxy">
                <q-date
                  ref="dateDialog"
                  minimal
                  today-btn
                  first-day-of-week="0"
                  :value="formattedPickerDate"
                  @input="inputDateDialog"
                  :options="validDates"
                ></q-date>
              </q-popup-proxy>
              &nbsp;{{ formattedDate }}
              <q-tooltip :delay="1000">
                Reservationsdatum setzen
              </q-tooltip>
            </q-btn>
            <q-btn :size="$q.platform.is.mobile ? 'sm' : ''" outline color="primary" icon="chevron_right" @click="jumpDate('day', 'for')">
            <q-tooltip :delay="1000">
              Einen Tag vor
            </q-tooltip>
            </q-btn>
            <q-btn
              :size="$q.platform.is.mobile ? 'sm' : ''"
              outline
              color="primary"
              icon="last_page"
              @click="jumpDate('week', 'for')"
              class="border-radius-0"
            >
            <q-tooltip :delay="1000">
              Eine Woche vor
            </q-tooltip>
            </q-btn>
            <q-btn
              :size="$q.platform.is.mobile ? 'sm' : ''"
              outline
              color="primary"
              icon="undo"
              @click="resetDesiredReservations"
              class="border-radius-0"
            >
            <q-tooltip :delay="1000">
              Reservationen zurücksetzen
            </q-tooltip>
            </q-btn>
            <!-- <q-btn outline color="primary" label="Reservationen" @click="reservationDialog = true" class="border-radius-0">anzeigen</q-btn> -->
          </q-btn-group>

          <div class="">
              <div
                v-if="selectedRoomIds.length === 0"
                class="text-capitalize text-subtitle1 text-grey-5 q-mt-sm q-pl-xl-md q-pl-md"
              >
                <div><q-icon name="arrow_upward" size="1.5em"></q-icon></div>  Bitte zuerst Räume auswählen
              </div>
              <div v-else>
                <div class="row">
                  <div v-if="showSchedule" class="col-shrink">
                    <DaySchedule/>
                  </div>
                  <div v-for="n in selectedRoomIds.length" :key="`${n}`" class="col">
                    <DayLessons
                      :myRoom="availableRooms[selectedRoomIds[n - 1]]"
                      v-on:removeSelectedRoom="removeSelectedRoom($event)"
                      v-on:showReservation="showReservation($event)"
                      v-on:showRoomDialog="roomDialog = true"
                      :roomIndex="n-1"
                      :active="room === null || availableRooms[selectedRoomIds[n - 1]].name === room.name"
                      :myReservationsOld="roomReservations(availableRooms[selectedRoomIds[n - 1]].name)"
                    />
                  </div>
                </div>
              </div>
          </div>
        </template>
      </q-tab-panel>

      <q-tab-panel name="show">
          <div>
            <q-toggle dense v-model="onlyUsersReservations">
              <span class="text-subtitle1"> Nur eigene Einträge anzeigen</span>
            </q-toggle>
          </div>
          <div>
            <div class="q-gutter-sm q-mb-lg q-mt-sm q-ml-none">
              <q-radio dense v-model="roomFilter" val="all" label="Alle Räume"></q-radio>
              <q-radio dense v-for="item in availableRooms" :key="item.key" v-model="roomFilter" :val="item.name" :label="item.name"></q-radio>
            </div>
          </div>
          <div v-if="getReservations().length === 0" class="q-ml-md q-mt-md text-subtitle1 text-grey-8">Es wurden keine Einträge gefunden</div>
          <div v-else>
          <q-list bordered separator class="q-mt-md">
            <q-item v-for="item in getReservations()" :key="item.key">
              <q-item-section top avatar>
                <q-avatar size="2rem" color="primary" text-color="white">
                  {{ item.signature }}
                </q-avatar>

                <div class="text-caption q-mt-xs">
                KW-{{ item.week }}
                </div>

              </q-item-section>

              <q-item-section top>
                <q-item-label lines="1">
                  <span class="text-weight-medium">
                    {{item.weekDay}}, {{ item.date }}, Zimmer {{ item.room }}</span
                  >
                </q-item-label>
                <q-item-label
                  :lines="$q.platform.is.desktop ? 1 : 2"
                  class="q-mt-xs text-body2 text-primary"
                >
                  Lektionen: {{ item.lessons }}, Klasse {{ item.course }}.
                  <span
                    v-if="item.comment"
                    class="q-mt-xs text-caption text-weight-light"
                    ><br />Kommentar: {{ item.comment }}</span
                  >
                </q-item-label>
              </q-item-section>

              <q-item-section top side>
                <div class="text-grey-8 q-gutter-xs">
                  <q-btn
                    size="12px"
                    flat
                    dense
                    round
                    icon="delete"
                    :disabled="username !== item.user"
                    @click="
                      deleteReservationIndex = item.key;
                      deleteReservationDialog = true;
                    "
                  />
                </div>
              </q-item-section>
            </q-item>
          </q-list>
          </div>
      </q-tab-panel>
    </q-tab-panels>
    <!-- room dialog -->
    <template>
      <div>
        <q-dialog v-model="roomDialog" class="q-pa-md">
          <q-card square>
            <q-card-section class="row items-center">
              <q-avatar icon="home" size="2rem" color="primary" text-color="white"/>
              <q-space/>
              <span v-if="room" class="q-ml-sm text-primary text-subtitle1">
              Räume auswählen
              </span>
              <q-space/>
              <q-btn icon="close" flat round dense v-close-popup/>
            </q-card-section>

            <q-separator/>
            <q-card-section style="max-height: 70vh" class="scroll">
              <div class>
                <q-option-group
                  :class="$q.platform.is.desktop ? '' : 'text-caption'"
                  :dense="$q.platform.is.mobile"
                  font="size:3"
                  :options="availableRooms"
                  label="Notifications"
                  type="checkbox"
                  v-model="selectedRoomIds"
                />
              </div>
            </q-card-section>
            <q-card-actions v-if="false" align="right" class="bg-white text-teal">
              <q-btn flat label="OK" v-close-popup/>
            </q-card-actions>
          </q-card>
        </q-dialog>
      </div>
    </template>
    <!-- reservation dialog -->
    <template>
      <div>
        <q-dialog v-model="reservationDialog" class="q-pa-md">
          <q-card square>
            <q-card-section class="row items-center">
              <q-avatar icon="home" size="2rem" color="primary" text-color="white"/>
              <q-space/>
              <span v-if="room" class="q-ml-sm text-primary text-subtitle1">
                Reservationen Zimmer {{ room.name }}
              </span>
              <q-space/>
              <q-btn icon="close" flat round dense v-close-popup/>
            </q-card-section>

            <q-separator/>
            <q-card-section style="max-height: 50vh" class="scroll">
              <q-list bordered separator>
                <q-item v-for="item in desiredReservations" :key="item.key">
                  <q-item-section>
                    {{ getReservationText(item) }}
                  </q-item-section>
                </q-item>
              </q-list>
            </q-card-section>
            <q-card-actions v-if="false" align="right" class="bg-white text-teal">
              <q-btn flat label="OK" v-close-popup/>
            </q-card-actions>
          </q-card>
        </q-dialog>
      </div>
    </template>
    <!-- confirm reservation dialog -->
    <template>
      <div>
        <q-dialog v-model="confirmReservationDialog" persistent :maximized="$q.platform.is.mobile" :medium="$q.platform.is.desktop" >
          <q-card style="padding:10px;width:700px;" class="border-radius-0">
            <q-card-section class="row items-center">
              <q-avatar
                icon="save"
                size="2rem"
                color="primary"
                text-color="white"
              />
              <span v-if="room" class="q-ml-sm text-primary text-subtitle1">
                Reservationen Zimmer {{ room.name }}
              </span>
            </q-card-section>
            <q-separator/>

            <q-card-section class="items-center">
              <div class="">
                <q-input
                  outlined
                  square
                  class="full-width text-grey-8 text-subtitle1 q-pb-xs"
                  label="Klasse/Kurs"
                  v-model="course"
                >
                </q-input>
              </div>
              <div class="">
                <q-input
                  autogrow
                  outlined
                  square
                  class="full-width text-grey-8 text-subtitle1"
                  label="Kommentar"
                  type="textarea"
                  v-model="comment"
                >
                </q-input>
              </div>
            </q-card-section>
            <q-card-section v-if="isSingleDayReservation" class="text-body1">
              <div v-if="getDesiredLessons().length === 1">
                Lektion: {{ getDesiredLessons() }}
              </div>
              <div v-else>
                Lektionen: {{ getDesiredLessons() }}
              </div>
              <div v-if="!isSingleDayReservation">
                Reservation am: {{ formattedPickerDate }}
                <br/>
                <br/>
              </div>
              <div v-else>
                Reservation von: {{ formattedPickerDate }}
                <br/>
                Reservation bis:
                  {{ formattedReservationsEndDate }}

                <span style="cursor:pointer;">
                  <q-popup-proxy ref="endDateProxy">
                    <q-date
                      ref="rangeDateDialog"
                      minimal
                      today-btn
                      first-day-of-week="0"
                      :value="formattedReservationsEndDate"
                      @input="inputEndDateDialog"
                      :options="validReservationsEndDates"
                    ></q-date>
                  </q-popup-proxy>
                  <q-icon name="today" size="1.1em"/>
                  </span>
              </div>
            </q-card-section>
            <q-card-section v-else class="text-body1">
              Reservationen:
              <q-list dense class="">
                <q-item v-for="item in multiReservations" :key="item.key">
                  <q-item-section>
                    {{ item.date }}{{ $q.platform.is.desktop ? ', Lektionen: ' : ', Lek.:' }}{{ item.lessons }}
                  </q-item-section>
                </q-item>
              </q-list>
            </q-card-section>

            <q-card-section v-if="isSingleDayReservation">
              <div :disabled="reservationsRange === 0">
                <div class="column q-gutter-sm q-pb-md">
                  <q-radio dense v-model="rangeType" val="weekly" label="wöchentlich" :disable="reservationsRange < 7">
                    <span class="text-caption text-weight-light">
                     (Gleiche Lektionen, gleicher Wochentag)
                    </span>
                  </q-radio>
                  <span q-gutter-sm>
                    <q-radio dense v-model="rangeType" val="daily" label="täglich" class="q-pr-md" :disable="!reservationsRange >= 1"/>
                    <q-checkbox dense v-model="weekendsIncluded" :disable="rangeType === 'weekly' || reservationsRange === 1" label="inkl. Wochenende"/>
                  </span>
                </div>

              </div>
              <div v-if="conflictingDays.length > 0">
                <div>
                  <q-icon name="announcement" class="text-red" style="font-size: 1.5em"></q-icon>
                <span v-if="conflictingDays.length === 1">
                  Konflikt am:
                </span>
                <span v-else>
                  Konflikte an folgenden Tagen:
                </span>
                </div>

              <q-list dense class="">
                <q-item v-for="item in conflictingDays" :key="item.key">
                  <q-item-section>
                    {{ item.date }}
                  </q-item-section>
                </q-item>
              </q-list>
              </div>

            </q-card-section>
            <q-separator/>
            <q-card-actions align="right" class="q-pt-md">
              <q-btn outline flat label="Abbrechen" v-close-popup class="border-radius-0"/>
              <q-btn
                outline
                flat
                class="border-radius-0"
                label="Reservieren"
                v-close-popup
                :disabled="!(desiredReservations.length > 0 && course && conflictingDays.length === 0)"
                @click="handleReservation"
              />
            </q-card-actions>
          </q-card>
        </q-dialog>
      </div>
    </template>
    <!-- show reservation dialog -->
    <template>
      <div>
        <q-dialog v-model="showReservationDialog">
          <q-card>
            <q-card-section class="row items-center">
              <q-avatar
                icon="info_outlined"
                size="2rem"
                color="primary"
                text-color="white"
              />
              <q-space/>
              <span v-if="room" class="q-ml-sm text-primary text-subtitle1">
              Reservation
              </span>
              <q-space/>
              <q-btn icon="close" flat round dense v-close-popup/>
            </q-card-section>
            <q-separator/>
            <q-card-section class="row items-center">
              <div class="q-ml-sm">
                Raum: {{ showReservationDialogData.room }}
                <br/>
                Datum: {{ formattedDate }}
                <br/>
                Lektion: {{ showReservationDialogData.lesson }}
                <br/>
                Lehrperson: {{ showReservationDialogData.signature }}
                <br/>
                Klasse/Kurs: {{ showReservationDialogData.course }}
                <span v-if="showReservationDialogData.comment">
                  <br/>
                  Kommentar: {{ showReservationDialogData.comment }}
                </span>
              </div>
            </q-card-section>
          </q-card>
        </q-dialog>
      </div>
    </template>
    <!-- delete reservation dialog -->
    <template>
      <div>
        <q-dialog
          v-if="!!deleteReservationIndex"
          v-model="deleteReservationDialog"
          persistent
        >
          <q-card style="padding:10px">
            <q-card-section class="row items-center">
              <q-avatar
                icon="delete"
                size="2rem"
                color="primary"
                text-color="white"
              />
              <span class="q-ml-sm text-primary text-subtitle1">
                Reservationen Zimmer {{ reservationsAgg[deleteReservationIndex].room }}
              </span>
            </q-card-section>
            <q-separator/>
            <q-card-section class="text-body1">
              <div>
                {{ reservationsAgg[deleteReservationIndex].weekDay }}, {{ reservationsAgg[deleteReservationIndex].date}}
              </div>
              <div v-if="getDesiredLessons().length === 1">
                Lektion: {{ getDesiredLessons() }}
              </div>
              <div v-else>
                Lektionen: {{ reservationsAgg[deleteReservationIndex].lessons }}
              </div>
              <div>
                Klasse: {{ reservationsAgg[deleteReservationIndex].course }}
              </div>
            </q-card-section>
            <q-separator/>
            <q-card-actions align="right" class="text-primary q-pt-md">
              <q-btn outline flat class="border-radius-0" label="Abbrechen" v-close-popup />
              <q-btn
                outline
                flat
                class="border-radius-0"
                label="Löschen"
                v-close-popup
                @click="handleDeleteReservation(deleteReservationIndex)"
              />
            </q-card-actions>
          </q-card>
        </q-dialog>
      </div>
    </template>
    <q-page-sticky v-if="desiredReservations.length > 0" position="bottom-right" :offset="[18, 18]">
      <q-btn fab icon="add" color="primary"
       @click="openReservationDialog()"
      />
    </q-page-sticky>
  </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import DayLessons from '../../components/DayLessons'
import DaySchedule from '../../components/DaySchedule'
import lodash from 'lodash'

export default {
  name: 'Reservations',
  components: { DayLessons, DaySchedule },

  data () {
    return {
      roomDialog: false,
      roomFilter: 'all',
      onlyUsersReservations: true,
      reservationDialog: false,
      tab: 'enter',
      step: 1,
      rooms: this.availableRooms,
      selectedRoomIds: [],
      selectedRooms: [],
      course: '',
      comment: '',
      showReservationDialog: false,
      showReservationDialogData: {},
      confirmReservationDialog: false,
      deleteReservationDialog: false,
      deleteReservationIndex: null,
      nbrOfWeeks: 1,
      reservationsEndDate: dayjs(),
      rangeType: 'daily',
      weekendsIncluded: false
    }
  },

  computed: {
    ...mapGetters('user', ['preferences', 'username', 'signature']),
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters('global', ['availableRooms', 'schedule']),
    ...mapGetters('reservations', [
      'pickerDate',
      'formattedPickerDate',
      'reservations',
      'roomReservations',
      'desiredReservations',
      'desiredRoomReservations',
      'reservationsAgg',
      'reservationsAggActive',
      'userReservationsAggActive',
      'week',
      'year',
      'weekDay'
    ]),
    room: {
      get: function () {
        return this.$store.getters['reservations/room']
      },
      set: function (val) {
        this.$store.dispatch('reservations/setRoom', val)
      }
    },
    reservationsTab: {
      get: function () {
        return this.$store.getters['reservations/reservationsTab']
      },
      set: function (val) {
        this.$store.dispatch('reservations/setReservationsTab', val)
      }
    },
    formattedDate () {
      return dayjs(this.pickerDate).format('DD.MM.YYYY')
    },
    formattedReservationsEndDate () {
      return dayjs(this.reservationsEndDate).format('DD.MM.YYYY')
    },
    reservationsRange () {
      return dayjs(this.reservationsEndDate).diff(this.pickerDate, 'day')
    },
    pickerLabel () {
      return dayjs(this.pickerDate).format('dddd')
    },
    // check pensum message
    showPensumMessage () {
      if (this.selectedRoomIds.length > 0) {
        //console.log(this.selectedRoomIds)
        for (var i = 0; i < this.selectedRoomIds.length; i++) {
          if (this.availableRooms[this.selectedRoomIds[i]].locked_lessons.pensum) {
            return true
          }
        }
      }
      return false
    },
    checkPensumRooms () {

    },
    showSchedule () {
      if (this.selectedRoomIds.length > 0) {
        if (this.$q.platform.is.desktop) {
          return true
        } else if (this.selectedRoomIds.length < 5) {
          return true
        }
      }
      return false
    },
    isSingleDayReservation () {
      if (this.desiredReservations.length >= 1) {
        var firstRes = this.desiredReservations[0]
        var sameDayReservations = this.desiredReservations.filter(function (el) {
          return el.year === firstRes.year && el.week === firstRes.week && el.day === firstRes.day
        })
        return sameDayReservations.length === this.desiredReservations.length
      }
      return true
    },

    conflictingReservations_copy: function () {
      if (this.room === null) {
        return []
      }

      var _this = this
      var relevantReservations = []
      var resEndDate = dayjs(this.reservationsEndDate).add(1, 'day') // include enddate!

      if (this.rangeType === 'weekly') {
        relevantReservations = this.reservations.filter(function (el) {
          return el.room === _this.room.name && el.day === _this.weekDay // same weekday
        })
      } else if (this.weekendsIncluded) {
        relevantReservations = this.reservations.filter(function (el) {
          return el.room === _this.room.name // same room
        })
      } else {
        relevantReservations = this.reservations.filter(function (el) {
          return el.room === _this.room.name && // same room
            (el.day !== 6 || el.day !== 0) // remove weekends
        })
      }

      // remove irrelevants
      relevantReservations = relevantReservations.filter(function (el) {
        var elDate = dayjs().year(el.year).week(el.week).day(el.day)
        return elDate.isAfter(_this.pickerDate) && elDate.isBefore(resEndDate)
      })

      if (relevantReservations.length === 0) {
        return relevantReservations
      }

      // filter all lessons
      var filteredReservations = []
      for (var i = 0; i < this.desiredReservations.length; i++) {
        for (var j = 0; j < relevantReservations.length; j++) {
          if (this.desiredReservations[i].lesson === relevantReservations[j].lesson) {
            filteredReservations.push(relevantReservations[j])
          }
        }
      }
      return filteredReservations
    },
    conflictingReservations: function () {
      if (this.room === null) {
        return []
      }

      var _this = this
      var relevantReservations = []
      var resEndDate = dayjs(this.reservationsEndDate).add(1, 'day') // include enddate!

      if (this.rangeType === 'weekly') {
        relevantReservations = this.reservations.filter(function (el) {
          return el.room === _this.room.name && el.day === _this.weekDay // same weekday
        })
      } else if (this.weekendsIncluded) {
        relevantReservations = this.reservations.filter(function (el) {
          return el.room === _this.room.name // same room
        })
      } else {
        relevantReservations = this.reservations.filter(function (el) {
          return el.room === _this.room.name && // same room
            (el.day !== 6 || el.day !== 0) // remove weekends
        })
      }

      // remove irrelevants
      relevantReservations = relevantReservations.filter(function (el) {
        var elDate = dayjs().year(el.year).week(el.week).day(el.day)
        return elDate.isAfter(_this.pickerDate) && elDate.isBefore(resEndDate)
      })

      if (relevantReservations.length === 0) {
        return relevantReservations
      }

      // filter all lessons
      var filteredReservations = []
      for (var i = 0; i < this.desiredReservations.length; i++) {
        for (var j = 0; j < relevantReservations.length; j++) {
          if (this.desiredReservations[i].lesson === relevantReservations[j].lesson &&
              this.desiredReservations[i].slot === relevantReservations[j].slot) {
            filteredReservations.push(relevantReservations[j])
          }
        }
      }
      return filteredReservations
    },
    conflictingDays_copy: function () {
      if (this.conflictingReservations.length === 0) {
        return []
      }

      var confDays = []
      var conflicts = []

      for (var i = 0; i < this.conflictingReservations.length; ++i) {
        var entry = {}
        entry.year = this.conflictingReservations[i].year
        entry.week = this.conflictingReservations[i].week
        entry.day = this.conflictingReservations[i].day
        conflicts = [...conflicts, entry]
      }

      while (conflicts.length > 0) {
        var conflict = conflicts[0]
        confDays = [...confDays, conflict]
        conflicts = conflicts.filter(function (el) {
          return !(el.year === conflict.year && el.week === conflict.week && el.day === conflict.day)
        })
      }

      for (i = 0; i < confDays.length; ++i) {
        confDays[i].date = dayjs().year(confDays[i].year).week(confDays[i].week).day(confDays[i].day).format('dddd, DD.MM.YYYY')
      }

      return lodash.sortBy(confDays, ['year', 'week', 'day'])
    },
    conflictingDays: function () {
      if (this.conflictingReservations.length === 0) {
        return []
      }

      var confDays = []
      var conflicts = []

      for (var i = 0; i < this.conflictingReservations.length; ++i) {
        var entry = {}
        entry.slot = this.conflictingReservations[i].slot
        entry.year = this.conflictingReservations[i].year
        entry.week = this.conflictingReservations[i].week
        entry.day = this.conflictingReservations[i].day
        conflicts = [...conflicts, entry]
      }

      while (conflicts.length > 0) {
        var conflict = conflicts[0]
        confDays = [...confDays, conflict]
        conflicts = conflicts.filter(function (el) {
          return !(el.slot === conflict.slot && el.year === conflict.year && el.week === conflict.week && el.day === conflict.day)
        })
      }

      for (i = 0; i < confDays.length; ++i) {
        confDays[i].date = dayjs().year(confDays[i].year).week(confDays[i].week).day(confDays[i].day).format('dddd, DD.MM.YYYY')
      }

      return lodash.sortBy(confDays, ['year', 'week', 'day'])
    },
    multiReservations: function () {
      if (this.desiredReservations.length === 0) {
        return []
      }

      var multiRes = []
      var desRes = [...this.desiredReservations]

      while (desRes.length > 0) {
        var entry = desRes[0]
        if (this.$q.platform.is.desktop) {
          entry.date = dayjs().year(entry.year).week(entry.week).day(entry.day).format('dddd, DD.MM.YYYY')
        } else {
          entry.date = dayjs().year(entry.year).week(entry.week).day(entry.day).format('dd, DD.MM.YYYY')
        }
        entry.lessons = ''
        for (var i = 0; i < desRes.length; ++i) {
          if (entry.year === desRes[i].year && entry.week === desRes[i].week && entry.day === desRes[i].day) {
            if (entry.lessons === '') {
              entry.lessons = desRes[i].lesson
            } else {
              entry.lessons = entry.lessons + ',' + desRes[i].lesson
            }
          }
        }

        multiRes = [...multiRes, entry]

        // remove already handled reservations
        desRes = desRes.filter(function (el) {
          return !(el.year === entry.year && el.week === entry.week && el.day === entry.day)
        })
      }
      return multiRes
    }
  },

  created () {
    if (!this.$store.getters['auth/isAuthenticated']) {
      this.$router.push('/login')
    } else {
      this.$store.dispatch('global/fetchAvailableRooms')
      this.$store.dispatch('reservations/fetchReservations')
      this.$store.dispatch('reservations/fetchReservationsAgg')
    }
    this.$store.dispatch('reservations/created')
  },

  mounted () {
    this.setSelectedRoomsFromPreferences()
  },

  methods: {
    getReservations() {
      if(this.onlyUsersReservations) {
        return this.userReservationsAggActive(this.roomFilter)
      }
      else {
        return this.reservationsAggActive(this.roomFilter)
      }
    },
    resetDesiredReservations () {
      this.$store.dispatch('reservations/setDesiredReservations', [])
    },
    getReservationText (res) {
      var date = dayjs().year(res.year).week(res.week).day(res.day)
      return date.format('dddd') + ', ' + date.format('DD.MM.YYYY') + ', Lektion: ' + res.lesson
    },
    getConflictingText (res) {
      var date = dayjs().year(res.year).week(res.week).day(res.day)
      return date.format('dddd') + ', ' + date.format('DD.MM.YYYY') + ', Lektion: ' + res.lesson
    },
    jumpDate (span, direction) {
      var newDate =
        direction === 'for'
          ? dayjs(this.pickerDate).add(1, span)
          : dayjs(this.pickerDate).subtract(1, span)

      if (newDate >= dayjs().subtract(1, 'day')) {
        this.$store.dispatch('reservations/setPickerDate', newDate)
      }
      this.reservationsEndDate = newDate
    },
    setSelectedRoomsFromPreferences () {
      if (this.availableRooms.length === 0) {
        this.selectedRoomIds = []
      } else {
        for (var i = 0; i < this.preferences.selectedRooms.length; i++) {
          this.selectedRoomIds.push(this.availableRooms[this.preferences.selectedRooms[i]].id)
        }
      }
    },
    removeSelectedRoom (room) {
      for (var i = 0; i < this.selectedRoomIds.length; i++) {
        if (this.selectedRoomIds[i] === room.value) {
          this.selectedRoomIds.splice(i, 1)
        }
      }
    },
    validDates (val) {
      // disable past weeks
      var inThePast = val >= dayjs().format('YYYY/MM/DD')
      return inThePast
    },
    validReservationsEndDates (val) {
      // disable past weeks
      var inThePast = val >= dayjs(this.pickerDate).format('YYYY/MM/DD')
      return inThePast
    },
    inputDateDialog (val) {
      this.$store.dispatch('reservations/setPickerDate', val)
      this.reservationsEndDate = val
      this.$refs.dateProxy.hide()
    },
    inputEndDateDialog (val) {
      this.reservationsEndDate = val
      this.rangeType = this.reservationsRange >= 7 ? 'weekly' : 'daily'
      this.$refs.endDateProxy.hide()
    },
    getReservation (day, lesson) {
      var res = this.reservations
      var r
      for (r in res) {
        if (res[r].day === day && res[r].lesson === lesson) {
          return res[r]
        }
      }
    },
    getDesiredLessons () {
      var lessons = ''
      if (this.isSingleDayReservation) {
        for (var i = 0; i < this.desiredReservations.length; i++) {
          if (lessons === '') {
            lessons = this.desiredReservations[i].lesson
          } else {
            lessons = lessons + ',' + this.desiredReservations[i].lesson
          }
        }
      }
      return lessons
    },
    showReservation (payload) {
      this.showReservationDialogData = payload
      this.showReservationDialog = true
    },
    openReservationDialog () {
      this.reservationsEndDate = this.pickerDate
      this.confirmReservationDialog = true
    },
    handleReservation () {
      if (this.isSingleDayReservation) {
        this.$store.dispatch('reservations/postReservationsRange', {
          course: this.course,
          comment: this.comment,
          reservationsEndDate: this.reservationsEndDate,
          rangeType: this.rangeType,
          weekendsIncluded: this.weekendsIncluded
        })
      } else {
        this.$store.dispatch('reservations/postReservations', {
          course: this.course,
          comment: this.comment
        })
      }
      this.course = ''
      this.comment = ''
      this.step = 1
      this.tab = 'show'
    },
    handleShowReservation () {
      this.$store.dispatch('reservations/deleteReservation', {
        course: this.course,
        comment: this.comment
      })
      this.course = ''
      this.comment = ''
      this.step = 2
    },
    handleDeleteReservation (val) {
      this.$store.dispatch(
        'reservations/deleteReservation',
        this.reservationsAgg[val]
      )
      this.deleteReservationIndex = null
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~quasar-variables'

.night {
  bg-color: blue;
}

.title {
  margin-top: 15px;
  margin-bottom: 11px;
}

.border-radius-0 {
  border-radius: 0px;
}

.my-button {
  size: $md;
  bg-color: red;
  &.mobile {
    size: $sm;
    bg-color: green;
  }
}
.q-tab-panel {
    padding: 16px 0px;
}

</style>
